<template>
  <content-creator
    :settings="blobContents"
    :permissions="contentCreatorPermissions"
    :is-visible="editContentCreator"
    :name="blobName"
    :filestore="websitefilestore"
    allowed-widgets="grid, link-list, advanced-wysiwyg-editor, wysiwyg-editor, carousel, content-list, content-grid, vimeo-video"
    @updateBlob="savePageContentBlob"
  />
</template>

<script>

import contentCreatorMixin from 'src/app/content-creator-mixin'

export default {
  name: 'page-content-creator',
  mixins: [
    contentCreatorMixin
  ],
  props: {
    itemid: {
      type: String,
      required: true
    },
    pos: {
      type: String,
      required: true
    }
  },
  computed: {
    blobName: function() {
      return `page-blob-${this.pos}--node-${this.itemid}`
    },
    blobContents: function() {
      return this.getBlobContents(this.blobName)
    }
  },
  methods: {
    savePageContentBlob: function(data) {
      this.saveBlob(this.blobName, data)
    }
  }
}
</script>

<style>

</style>
